module.exports = __webpack_public_path__ + "img/1-5.8b5c605b.svg";